<script setup lang="ts">
import { computed, ComputedRef } from 'vue'

import {
  IncidentId,
  RugbyLeagueIncidentId,
  RugbyUnionIncidentId,
  SportId,
} from '@collector/sportsapi-client-legacy'
import { useEvent } from '@desktop/views/Relation/composables'
import BetStatusButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/BetButton/BetStatusButton.vue'
import PocketIncidents from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidents.vue'
import PocketIncidentsTeamSelectionButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidentsTeamSelectionButton.vue'

// composables
const { event } = useEvent()

// computed
const pocketIncidentsRequiringTeamSelection: ComputedRef<IncidentId[]> =
  computed(() => {
    if (event.value.sport_id === SportId.RugbyLeague) {
      return [
        RugbyLeagueIncidentId.Timeout,
        RugbyLeagueIncidentId.Injury,
        RugbyLeagueIncidentId.MedicalTimeout,
      ]
    } else if (event.value.sport_id === SportId.Rugby) {
      return [
        RugbyUnionIncidentId.Timeout,
        RugbyUnionIncidentId.Injury,
        RugbyUnionIncidentId.MedicalTimeout,
      ]
    }
    return []
  })

function isTeamSelectionButtonVisible(incidentId: IncidentId): boolean {
  return pocketIncidentsRequiringTeamSelection.value.includes(incidentId)
}
</script>

<template>
  <PocketIncidents>
    <template #pocketIncidentButton="{ incidentId, title }">
      <PocketIncidentsTeamSelectionButton
        v-if="isTeamSelectionButtonVisible(incidentId)"
        :incidentId
        :title
      />
    </template>
    <template #betButtons>
      <BetStatusButton class="w-full" />
    </template>
  </PocketIncidents>
</template>
